document.addEventListener("DOMContentLoaded", () => {
  // =========================================
  // BANNER ANIMATIONS
  // =========================================

  gsap.from(".banner__heading", {
    y: 50,
    opacity: 0,
    duration: 1,
    ease: "power3.out",
  });

  gsap.from(".banner__buttons", {
    y: 30,
    opacity: 0,
    duration: 1.2,
    ease: "power3.out",
  });

  // =========================================
  // MEDIA CARDS ANIMATIONS
  // =========================================

  // Make sure ScrollTrigger is available
  if (typeof ScrollTrigger !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);
  }

  const mediaCardSections = document.querySelectorAll(
    ".media-cards:not(.media-cards--observer)"
  );

  mediaCardSections.forEach((section) => {
    // -----------------------------------------
    // Section Heading
    // -----------------------------------------

    const heading = section.querySelector(".media-cards__heading");

    if (heading) {
      gsap.from(heading, {
        scrollTrigger: {
          trigger: heading,
          start: "top 85%",
          once: true,
        },

        y: 50,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
      });
    }

    // -----------------------------------------
    // Media Cards
    // -----------------------------------------

    const cards = section.querySelectorAll(
      ".media-card:not(.media-card--clone)"
    );

    if (!cards.length) return;

    // Cards fade + slide upward
    gsap.from(cards, {
      scrollTrigger: {
        trigger: cards[0],
        start: "top 85%",
        once: true,
      },

      y: 70,
      opacity: 0,
      duration: 0.9,
      stagger: 0.15,
      ease: "power3.out",
    });

    // -----------------------------------------
    // Media/Image Animation
    // -----------------------------------------

    cards.forEach((card) => {
      const media = card.querySelector(".media-card__media");

      if (media) {
        gsap.from(media, {
          scale: 1.08,
          duration: 1.2,
          ease: "power3.out",

          scrollTrigger: {
            trigger: card,
            start: "top 85%",
            once: true,
          },
        });
      }

      // -----------------------------------------
      // Card Text Animation
      // -----------------------------------------

      const content = card.querySelector(".media-card__text-wrapper");

      if (!content) return;

      const contentItems = content.querySelectorAll(
        ".media-card__heading, .media-card__description, .media-card__button"
      );

      if (!contentItems.length) return;

      gsap.from(contentItems, {
        y: 30,
        opacity: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: "power2.out",

        scrollTrigger: {
          trigger: card,
          start: "top 80%",
          once: true,
        },
      });
    });
  });
});

